import { useState } from 'react';

export default () => {
  const [cloudList, setCloudList] = useState<any>([]);

  return {
    cloudList,
    setCloudList
  }
}
